import { StringKey } from '../../../../lang/index';

export enum SignatureScopeFilter {
  ALL = 'all',
  MY_SIGNATURES = 'my-signatures',
}

export const signatureScopeFilterMap: SignatureScopeFilter[] = [
  SignatureScopeFilter.ALL,
  SignatureScopeFilter.MY_SIGNATURES,
];

export const signatureScopeTranslationKey: Record<SignatureScopeFilter, StringKey> = {
  [SignatureScopeFilter.ALL]: 'FILTER_ALL',
  [SignatureScopeFilter.MY_SIGNATURES]: 'FILTER_MY_SIGNATURES',
};
